<template>
  <div class="rb-confirm" ref="elConfirm">
    <div class="rb-confirm-bottom">
      <pricing-details :with-stock-status="false" />
      <div class="rb-cta">
        <button
          aria-label="Add to Cart"
          class="btn rb-btn-atc"
          @click.prevent="notifyAddToBag"
          :disabled="loading"
          id="btn-add-to-cart"
        >
          <span>Add to Bag</span>
          <loader v-if="loading" />
        </button>
      </div>
      <!-- <div class="rb-confirm-bottom-wrap">
        <div class="rb-pricing">
          <pricing prev="Total Price" />
          <stock-status-description />
        </div>
        <div class="rb-cta">
          <button
            aria-label="Add to Cart"
            class="btn rb-btn-atc"
            @click.prevent="notifyAddToBag"
            :disabled="loading"
          >
            <span>Add to Bag</span>
            <loader v-if="loading" />
          </button>
        </div>
      </div> -->
    </div>
    <div class="rb-top">
      <h2>{{ product.title }}</h2>
      <a href="#" @click.prevent="notifyShare" id="btn-share">
        <span>Share</span>
      </a>
    </div>
    <share-nav
      v-if="showShareOptions"
      :data="{ urlShop, product, socialShare }"
      :product="product"
    />
    <div class="rb-mid" v-if="showClearSavedForLater">
      <button
        aria-label="Clear All Selections"
        @click.prevent="clearSavedForLater"
      >
        Clear All Selections
      </button>
    </div>
    <summary-option
      v-for="(summary, indexStep) in summarySteps"
      :summary="summary"
      :selected-options="selectedOptions"
      :key="`summary-step-${indexStep}`"
    />
    <div class="rb-bottom">
      <div class="rb-pricing">
        <!-- <pricing prev="Total Ring Price " prev-complete="Total Ring Price " /> -->
        <pricing-details />
      </div>
      <div class="rb-cta">
        <button
          aria-label="Add to Cart"
          class="btn rb-btn-atc"
          @click.prevent="notifyAddToBag"
          :disabled="loading"
          id="btn-add-to-cart"
        >
          <span>Add to Bag</span>
          <loader v-if="loading" />
        </button>
      </div>
    </div>
    <div class="rb-sold-out" v-if="soldOut">
      The diamond you selected has been sold. Please try again.
    </div>
    <help-panel />
  </div>
</template>
<script>
/**
 * Widget to display a summary of customer slections
 *
 * @props
 * product: Object
 * mappings: Object
 * api: Object
 * urlShop: String
 * socialShare: Object
 *
 * @implements
 * ChildMixin
 * CommMixin
 * TrackMixin
 * PriceMixin
 *
 * @listens
 * rb-sold-out
 * rb-step-display-update
 *
 * @emits
 * rb-save-for-later-delete
 * rb-sold-out
 * rb-add-to-bag
 */
import ChildMixin from "@/mixins/ChildMixin";
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import PriceMixin from "@/mixins/PriceMixin";
import SummaryOption from "@/components/SummaryOption";
// import Pricing from "@/components/Pricing";
import PricingDetails from "@/components/PricingDetails";
import HelpPanel from "@/components/HelpPanel";
import ShareNav from "@/components/ShareNav";
import Loader from "@/components/Loader";
// import StockStatusDescription from "@/components/StockStatusDescription";
import {
  getSavedForLater,
  getSelectedVariants,
  getShopifyDiamond,
  formatCarat,
  isMobile,
} from "../lib";
export default {
  mixins: [ChildMixin, CommMixin, TrackMixin, PriceMixin],
  components: {
    //Pricing,
    PricingDetails,
    SummaryOption,
    HelpPanel,
    Loader,
    ShareNav,
    // StockStatusDescription,
  },
  props: {
    product: {
      type: Object,
    },
    mappings: {
      type: Object,
    },
    api: {
      type: Object,
    },
    urlShop: {
      type: String,
    },
    socialShare: {
      type: Object,
    },
  },
  data: function () {
    return {
      loading: false,
      showClearSavedForLater: false,
      soldOut: false,
      showShareOptions: false,
      originalContentHeight: 0,
      elScrollable: null,
      summarySteps: [
        { title: "Stone Shape", id: "shape" },
        { title: "Precious Metal", id: "metal" },
        { title: "Signature Stone®", id: "signature" },
        { title: "Ring Size", id: "size" },
        { title: "Engraving", id: "engraving" },
        { title: "Your Diamond", id: "diamond" },
      ],
    };
  },
  mounted: function () {
    this.checkSavedForLater();
    this.subscribe("rb-sold-out", this.onSoldOut);
    this.subscribe("rb-step-display-update", this.onStepDisplayUpdate);
  },
  methods: {
    onStepDisplayUpdate: function (data) {
      if (data.id === "summary") {
        // console.log('fixing');
        this.$nextTick(() => {
          this.fixLargeScreen();
        });
      }
    },
    fixLargeScreen: function () {
      if (isMobile()) return;
      this.onLargeScreenResize();
      window.addEventListener("resize", this.onLargeScreenResize);
    },
    onLargeScreenResize: function () {
      this.elScrollable = this.$refs.elConfirm.parentNode;
      if (this.originalContentHeight === 0) {
        var elScrollableHeight = this.elScrollable.offsetHeight;
        this.originalContentHeight = elScrollableHeight + 100;
      }

      var docHeight = Math.min(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );

      // console.log(this.originalContentHeight, docHeight);
      if (this.originalContentHeight > docHeight) {
        this.elScrollable.style.height = `${docHeight - 100}px`;
        this.elScrollable.style.overflowY = "scroll";
        this.elScrollable.style.paddingRight = "2em";
      } else {
        this.elScrollable.style.height = null;
        this.elScrollable.style.overflowY = null;
        this.elScrollable.style.paddingRight = null;
      }
    },
    onSoldOut: function () {
      this.soldOut = true;
    },
    notifyShare: function (event) {
      // this.broadcast("rb-open-popup", { id: "rb-popup-share" });
      this.showShareOptions = true;
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
    checkSavedForLater: function () {
      var dataSavedForLater = getSavedForLater();
      if (dataSavedForLater && dataSavedForLater.length) {
        this.showClearSavedForLater = true;
      }
    },
    clearSavedForLater: function () {
      this.broadcast("rb-save-for-later-delete");
    },
    notifyAddToBag: async function () {
      var selectedVariants = getSelectedVariants(
        this.selectedOptions,
        this.product,
        this.mappings
      );

      // console.log(selectedVariants);
      if (selectedVariants.length > 1) return; // @TODO: throw error

      var signatureStone = this.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "signature"
      )?.choice.label;
      var ringSize = this.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "size"
      )?.choice.label;
      var engraving = this.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "engraving"
      )?.choice.value;

      var diamond = this.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "diamond"
      )?.choice;

      this.soldOut = false;
      this.loading = true;
      var shopifyDiamondData = await getShopifyDiamond(
        this.api.diamondsApp.baseUrl,
        diamond.cert_num
      );
      this.loading = false;
      // console.log(diamond);
      // console.log(shopifyDiamondData);
      if (!shopifyDiamondData.available) {
        this.broadcast("rb-sold-out");
        return;
      }

      var bundleId = `${Date.now()}${parseInt(Math.random() * 100000)}`;

      var settingProperties = {
        _bundle_id: bundleId,
        _bundle_item: "main",
        _is_engagement_ring: true,
        "Signature Stone®": signatureStone,
        "Ring Size": ringSize,
        Engraving: engraving,
      };
      var stockStatusDescription =
        selectedVariants[0]?.metafields_custom?.stock_status_description || "";
      if (stockStatusDescription) {
        settingProperties["_stock_status_description"] = stockStatusDescription;
      }

      var cartItems = [];
      var ringItem = {
        id: selectedVariants[0].id,
        quantity: 1,
        properties: settingProperties,
      };

      var diamondItem = {
        id: shopifyDiamondData.variant_id,
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_item: "related_single",
          _cert_num: diamond.cert_num,
          _cert_url: diamond.cert_url,
          _is_diamond: true,
          SKU: diamond.sku,
          "GIA Certificate": diamond.cert_num,
          Shape: diamond.shape,
          "Carat Weight": formatCarat(diamond.size),
          Color: diamond.color,
          Clarity: diamond.clarity,
        },
      };

      cartItems = [diamondItem, ringItem];

      this.broadcast("rb-add-to-bag", { cartItems });

      // this.trackAddToBag(this.product, selectedVariants, shopifyDiamondData);
    },
    trackAddToBag: function (product, selectedVariants, shopifyDiamondData) {
      // Validating data to prevent an error when adding to bag
      var shopifyRingId =
        selectedVariants && selectedVariants.length > 0 && selectedVariants[0]
          ? `shopify_US_${product.id}_${selectedVariants[0].id}`
          : `shopify_US_${product.id}`;
      var shopifyDiamondId =
        shopifyDiamondData && shopifyDiamondData.variant_id
          ? `shopify_US_${shopifyDiamondData.variant_id}`
          : `shopify_US_diamond`;
      var trackRingTitle =
        selectedVariants && selectedVariants.length > 0 && selectedVariants[0]
          ? `${product.title} + ${selectedVariants[0].title}`
          : product.title;
      var trackDiamondTitle =
        shopifyDiamondData && shopifyDiamondData.handle
          ? shopifyDiamondData.handle.split("-").join(" ")
          : "Diamond";
      var trackRingVariantTitle =
        selectedVariants && selectedVariants.length > 0 && selectedVariants[0]
          ? selectedVariants[0].title
          : "";
      // gathering dataLayer info
      var dataLayer = {
        ecomm_prodid: [shopifyRingId, shopifyDiamondId],
        ecomm_totalvalue: this.totalPrice,
        ecomm_pagetype: "cart",
        value: this.totalPrice,
        currency: "USD",
        items: [
          {
            id: shopifyRingId,
            name: trackRingTitle,
            brand: this.product.vendor,
            category: "engagement-rings",
            price: this.baseRingPrice,
            quantity: "1",
            variant: trackRingVariantTitle,
          },
          {
            id: shopifyDiamondId,
            name: trackDiamondTitle,
            category: "diamonds",
            price: this.diamondPrice,
            quantity: "1",
          },
        ],
      };
      // track
      this.trackEvent(
        this.formatTracking("add_to_cart", this.TRACK_CLICK),
        "add_to_cart",
        dataLayer
      );
    },
  },
};
</script>
